<router-outlet> </router-outlet>
<app-footer></app-footer>

<div class="fb-customerchat" page_id="106873581578130" minimized="false"></div>

